export class PrimitivesEntity {
  static parseBooleanOrString(value) {
    if (typeof value === 'boolean') {
      return value;
    } else {
      const n = parseInt(value);
      return Boolean(n);
    }
  }
}
